/**
 * File drop zone for the infrastructure import modal.
 *
 * Extracted from ImportModal.tsx (Sub-PR 6.4).
 */

import { useTranslation } from 'react-i18next'
import { FileUp } from 'lucide-react'

interface FileDropZoneProps {
  dragActive: boolean
  onDrag: (e: React.DragEvent) => void
  onDrop: (e: React.DragEvent) => void
  onBrowse: () => void
  fileInputRef: React.RefObject<HTMLInputElement>
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function FileDropZone({
  dragActive,
  onDrag,
  onDrop,
  onBrowse,
  fileInputRef,
  onInputChange,
}: FileDropZoneProps): React.ReactElement {
  const { t } = useTranslation('cases')
  const borderClass = dragActive
    ? 'border-blue-500 bg-blue-50 dark:bg-blue-950/20'
    : 'border-slate-300 dark:border-slate-600 hover:border-slate-400 dark:hover:border-slate-500'
  const iconClass = dragActive ? 'text-blue-500' : 'text-slate-400 dark:text-slate-500'

  return (
    <div
      onDragEnter={onDrag}
      onDragLeave={onDrag}
      onDragOver={onDrag}
      onDrop={onDrop}
      className={`flex flex-col items-center justify-center rounded-xl border-2 border-dashed p-12 transition-colors ${borderClass}`}
    >
      <FileUp className={`h-12 w-12 ${iconClass}`} />
      <p className="mt-4 text-center text-slate-600 dark:text-slate-400">
        {t('infrastructure.import.dragDropText')}{' '}
        <button onClick={onBrowse} className="text-blue-600 hover:underline dark:text-blue-400">
          {t('infrastructure.import.browse')}
        </button>
      </p>
      <p className="mt-2 text-sm text-slate-500 dark:text-slate-500">
        {t('infrastructure.import.supportsFormats')}
      </p>
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv,.json"
        onChange={onInputChange}
        className="hidden"
      />
    </div>
  )
}
